<div [class]="to.className">
    <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onClick($event)" [hidden]= "to.hidden" [formlyAttributes]="field" [innerHTML]="to.text">

    </button>
</div>